import { Button } from "antd";
import React, { useEffect, useState } from "react";

import * as Common from "../commons/common";
import * as Utils from "../utils/utils";

function ProcessLayout({ children, bottomText }: { children: React.ReactNode; bottomText: string }) {
    const [disabledProcessButton, setDisabledProcessButton] = useState(true);

    useEffect(() => {
        Utils.onEvent(Common.EVENT_ENABLE_PROCESS_BUTTON, onEnableProcessButton);

        return () => {
            Utils.offEvent(Common.EVENT_ENABLE_PROCESS_BUTTON, onEnableProcessButton);
        };
    }, []);

    const onEnableProcessButton = (data: CustomEvent) => {
        setDisabledProcessButton(!data.detail);
    };

    return (
        <>
            <div style={{ overflowY: "scroll", overflowX: "hidden", height: "calc(100vh - 75px - 45px)" }}>{children}</div>
            <Button
                style={{
                    height: "45px",
                    textAlign: "center",
                    position: "absolute",
                    width: "calc(100vw - 32px)",
                    left: "50%",
                    transform: "translate(-50%, 0)",
                }}
                disabled={disabledProcessButton}
                onClick={() => Utils.triggerEvent(Common.EVENT_NEXT_PROCESS)}
            >
                {bottomText}
            </Button>
        </>
    );
}

export default ProcessLayout;
